import { render, staticRenderFns } from "./CvBody.vue?vue&type=template&id=fd7ad546&"
import script from "./CvBody.vue?vue&type=script&lang=js&"
export * from "./CvBody.vue?vue&type=script&lang=js&"
import style0 from "./CvBody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports